
import { ErrorMessage, Field, useFormikContext } from 'formik'
import React from 'react'

export const NipField = ( props )=>{
  const { name , placeholder, id, handleChange, setFieldValue} = props
  const {errors, touched} = useFormikContext();
  return(
    <React.Fragment>
      <div className={'form-floating'}>
        <Field
          className={errors[name] && touched[name] ? 'form-control error':'form-control'}
          id={id}
          name={name}
          placeholder={placeholder}
          onChange={
            (event) => {
              handleChange(event)
              let value = event.target.value
              let filtered = value.replace(/\D/g, '')
              if (value !== filtered) {
                setFieldValue(name, filtered)
              }
            }}
          type={'tel'}
          pattern={'[0-9]{10}'}
        />
        <label htmlFor={id}>{placeholder}</label>
      </div>
      <ErrorMessage
        name={name}
        component="div"
        className="field-error"
      />
    </React.Fragment>
  )


}